 /* jshint esversion: 6 */
 export default {
  LOAD_MSG_INFO: ({ commit }, { isNotice = false }) => {},
};
